import Head from 'next/head'
import Layout from 'layout/Layout'
import SectionLayout from 'layout/Section'

import styles from 'styles/pages/sorry/Error.module.scss'

import Heading from 'component/atoms/heading/_Heading'
import ButtonLink from 'component/atoms/button/_ButtonLink'
import { useUtilHooks } from 'hooks/common/useUtilHooks'

const Sorry = () => {
  const { t, Trans } = useUtilHooks()

  return (
    <Layout onlylang>
      <Head>
        <title>
          {
            t(
              'ID-NC-VF0121_WID1131'
            ) /* SPL:エラーメッセージ（複数言語）（システムエラー画面とURLエラー画面）*/
          }
        </title>
        <meta
          name="description"
          content={
            t(
              'ID-NC-VF0121_WID1131'
            ) /* SPL:エラーメッセージ（複数言語）（システムエラー画面とURLエラー画面）*/
          }
        />
        <link rel="icon" href="/img/favicon/favicon.ico" sizes="32x32" />
        <link rel="icon" href="/img/favicon/icon.svg" type="image/svg+xml" />
        <link rel="apple-touch-icon" href="/img/favicon/apple-touch-icon.png" />
        <link rel="manifest" href="/manifest.webmanifest" />
        <script src={`${process.env.NEXT_PUBLIC_AA_COMMON}`} async></script>
      </Head>

      <SectionLayout classMargin="is-margin-40" contentsWidth="is-min">
        <div className="l-inner">
          <Heading level="1" size="2" content="">
            {/* 2024/07/12 FCN改修 中国版sorry页面修改 start */}
            {/* URL-Fehler error
            <br />
            URL error
            <br />
            Error de URL
            <br />
            Erreur d’URL
            <br />
            Errore URL
            <br />
            URL エラー
            <br /> */}
            网址错误
            {/* <br />
            錯誤
            <br />
            URL 오류
            <br />
            URL-fout
            <br />
            URL hatasi
            <br />
            Ошибка URL */}
            {/* 2024/07/12 FCN改修 中国版sorry页面修改 end */}
          </Heading>
        </div>

        <div className="l-inner is-margin-40">
          <div className={styles.error}>
            {/* 2024/07/12 FCN改修 中国版sorry页面修改 start */}
            {/* <p>
              Deutsch
              <br />
              Es ist ein Fehler aufgetreten. Bitte versuchen Sie es in ein paar
              Minuten nocheinmal.
            </p>
            <p>
              English
              <br />
              The requested URL cannot be found on this server.
            </p>
            <p>
              Español
              <br />
              Se h a producido un error. Por favor, inténtelo de nuevo en unos
              minutos.
            </p>
            <p>
              Français
              <br />
              Une erreur s’est produite. Veuillerz réessayer dans quelques
              .minutes.
            </p>
            <p>
              Italiano
              <br />
              Si e venficato un errore. Si prega di
            </p>
            <p>
              日本語
              <br />
              ページが見つかりません
            </p> */}
            <p>
              {/* 中文(簡体) */}
              <br />
              {/* 发生了一个战误。请在几分特后再球。 */}
              发生了一个错误。请在几分钟后再试。
            </p>
            {/* <p>
              中文(繁體)
              <br />
              發牛 了餵辉。 抱歉。請柠後市坊間。
            </p>
            <p>
              한국
              <br />
              오류가발생했습니다.죄송합니다.잠시후다시액세스해주세요.
            </p>
            <p>
              Nederlands
              <br />
              Er is provatrrea qualche minuto.
            </p>
            <p>
              Türkce
              <br />
              Bir hata clustu. Uzgünüm, ama lütfen bir süre sonra tekraerigin.
            </p>
            <p>
              Русский
              <br />
              Произошошлиабка. Пожалуйпсотав,торитпеопытчкеурнеезсколько минут.
            </p> */}
            {/* 2024/07/12 FCN改修 中国版sorry页面修改 end */}
          </div>
        </div>

        <div className="l-inner is-margin-120">
          <div className={styles.button}>
            <ButtonLink
              url="/home"
              label={
                <Trans i18nKey={'ID-NC-VF011901_WID0154'} /* SPL:ホーム */ />
              }
              icon="arrow"
              position="right"
              type="square"
              size="middle"
              reverse={false}
              color=""
              alignCenter={false}
            />
          </div>
        </div>
      </SectionLayout>
    </Layout>
  )
}

export default Sorry
